import { render } from "./Filesync.vue?vue&type=template&id=c4440ce6"
import script from "./Filesync.vue?vue&type=script&lang=js"
export * from "./Filesync.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/eventgallery/build/tmpBuildDir/components/com_eventgallery/media/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"backend/vue/filesync/Filesync.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c4440ce6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c4440ce6', __exports__)) {
    api.reload('c4440ce6', __exports__)
  }
  
  module.hot.accept("./Filesync.vue?vue&type=template&id=c4440ce6", () => {
    api.rerender('c4440ce6', render)
  })

}


export default __exports__